<template>
  <div style="height: 100%">
    <div class="img">
      <!-- <img src="../assets/images/login_background.svg" alt="" /> -->
    </div>
    <div class="opacity_wrapper"></div>
    <div class="form_container">
      <div class="section1">
        <img calss="img_logo" src="../assets//images/joyworks_logo2.png" alt="" />
        <div class="section1_text">조이웍스<span class="text_highLight">A/S 온라인 신청서</span></div>
      </div>
      <div class="section2">
        <div @click="registPage" class="img_box">
          <img src="../assets/images/clothes.png" alt="" />
          <div class="img_text">수선등록</div>
        </div>
        <div @click="detailListPage" class="img_box">
          <img src="../assets/images/status.png" alt="" />
          <div class="img_text">상태조회</div>
        </div>
      </div>
      <div class="section3">
        <div class="img_box logout_box" @click="logout">
          <img src="../assets/images/login_enter.png" alt="" />
          <div class="img_text">로그아웃</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import authAPI from "@/api/authAPI";
import router from "@/router";
import { onMounted } from "vue";

onMounted(() => {
  checkSession();
});
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};

const logout = () => {
  window.customConfirm({
    title: "로그아웃",
    msg: "로그아웃 하시겠습니까?",
    sCb: () => {
      authAPI.logout().then(() => {
        router.push({ name: "clientLogin" });
      });
    },
  });
};

const registPage = () => {
  router.push({ name: "clientRegist" });
};

const detailListPage = () => {
  router.push({ name: "clientDetailList" });
};
</script>
<style scoped>
.opacity_wrapper {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  position: fixed;
  top: 0px;
  left: 0px;
}
.form_container {
  background: #f9f9f9;
  position: fixed;
  top: calc(0%);
  right: calc(10%);
  width: 382px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.img {
  height: 940px;
}
.img > img {
  width: 100%;
  height: 100%;
}
.section1 {
  display: flex;
  flex-direction: column;
  gap: 11px;

  height: 266px;
  align-items: center;
  justify-content: center;
}
.section1_text {
  font-size: 17px;
  font-family: "Noto Sans CJK KR-Medium";
  letter-spacing: -0.5px;
  line-height: 36px;
  display: flex;
  gap: 8px;
}
.text_highLight {
  font-family: "Noto Sans CJK KR-Bold";
  color: #006da0;
}
.section2 {
  display: flex;
  padding: 0px 50px 0px 50px;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 425px;
}
.section3 {
  display: flex;
  padding: 0px 50px 0px 50px;
  gap: 12px;
  justify-content: center;
}
.img_box {
  border: 2px solid #d0d0d0;
  width: 122px;
  height: 122px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  cursor: pointer;
}
.logout_box {
  border: none;
  width: 122px;
  height: 122px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  cursor: pointer;
}
.img_box > img {
  margin-top: 10px;
  width: 51px;
  height: 51px;
}
.img_text {
  font-size: 14px;
  line-height: 36px;
  letter-spacing: -0.5px;
  font-family: "Noto Sans CJK KR-Bold";
}
</style>
